import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppIntegrationAccountApiService } from '../../../shared';
import { IAppIntegrationAccount } from '../../../shared/interfaces/app-integration-account.interface';
import { trackByLabel } from '../../../shared/util/track-by.util';

import { SnackBarConfig } from './../../../shared/configs/snackbar.config';
import { AppIntegrationAccountConfig } from './../../configs/app-integration-account.config';

//INTERFACE

//SERVICE

@Component({
  selector: 'lum-app-integration-account-manage',
  templateUrl: './app-integration-account-manage.component.html',
  styleUrls: ['./app-integration-account-manage.component.scss'],
})
export class AppIntegrationAccountManageComponent implements OnInit, OnDestroy {
  activeLink :string;
  tabs :any[] = [];
  currentAppIntegrationId :number;
  appIntegrationAccount :IAppIntegrationAccount;

  private onDestroy$ = new Subject<void>();

  trackByLabel = trackByLabel;

  constructor(
    private appIntegrationAccountApiService :AppIntegrationAccountApiService,
    private router :Router,
    private route :ActivatedRoute,
    private snackBar :MatSnackBar,
    private cd :ChangeDetectorRef,
  ) {}

  ngOnInit() :void {
    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (id) {
      this.currentAppIntegrationId = id;
    }

    this.getAppIntegrationAccount();
    this.initActiveLink();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private initActiveLink() :void {
    this.activeLink = this.router.url;
  }

  private getAppIntegrationAccount() :void {
    this.appIntegrationAccountApiService
      .getById(this.currentAppIntegrationId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (appIntegrationAccount :IAppIntegrationAccount) => {
          this.appIntegrationAccount =
            appIntegrationAccount || ({} as IAppIntegrationAccount);
          this.updateTabsBasedOnSettings();
          this.updateAccountManageTabLinks();
          this.cd.detectChanges();
        },
        error: (error) => {
          this.snackBar.open(
            error.message || 'Failed to get app integration account',
            'Fail',
            {
              duration: SnackBarConfig.DEFAULT.duration,
            },
          );
        },
      });
  }

  private updateTabsBasedOnSettings() :void {
    this.tabs = AppIntegrationAccountConfig.accountManageTabs.filter(
      (tab) =>
        this.appIntegrationAccount.settings &&
        this.appIntegrationAccount.settings[tab.setting] === 'true',
    );
  }

  private updateAccountManageTabLinks() :void {
    this.tabs.forEach((tab) => {
      tab.link = tab.link.replace(/:id/, this.currentAppIntegrationId.toString());
    });
  }
}
